import gql from 'graphql-tag';

export const GET_ORDER = gql`
  query GetOrder($orderId: ID!) {
    order: Order(id: $orderId) {
      id
      origin
      estimatedFinishTime
      desiredTime
      payment {
        id
        type
      }

      user {
        id
        name
      }
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($orderId: ID!, $status: ORDER_STATUS) {
    updateOrder(id: $orderId, status: $status) {
      id
      status
    }
  }
`;

// Accepts an order
export const ACCEPT_ORDER = gql`
  mutation AcceptPendingOrder($id: ID!, $status: ORDER_STATUS, $estimatedFinishTime: String) {
    updateOrder(id: $id, status: $status, estimatedFinishTime: $estimatedFinishTime) {
      id
      status
    }
  }
`;

// Rejects an order
export const REJECT_ORDER = gql`
  mutation RejectPendingOrder($id: ID!, $rejectReason: String!) {
    setOrderRejected(orderId: $id, rejectReason: $rejectReason) {
      success
      error
      message
    }
  }
`;

export const UPDATE_ORDER_ESTIMATE = gql`
  mutation updateOrderEstimate($id: ID!, $estimatedFinishTime: String) {
    updateOrder(id: $id, estimatedFinishTime: $estimatedFinishTime) {
      id
      estimatedFinishTime
    }
  }
`;

// fragmet of order
const FULL_ORDER_FRAGMENT = gql`
  fragment PendingOrderFragment on Order {
    id
    status
    createdAt
    type
    comment
    easyId
    origin
    tableId

    estimatedFinishTime
    desiredTime
    remindTimer

    user {
      id
      name
      phone
      language
    }

    payment {
      type
      amount
      correctedTip
    }

    thirdPartyMetadata {
      id
      client
    }

    richVariations

    items {
      id
      bundleId
      message
      price {
        amount
        discount
        percentageVAT
      }

      offer {
        id
        name
        nameLang {
          id
          en
          se
          no
          es
        }
      }
      variations {
        id
        name
        highlighted
        asItem {
          id
        }
        tags
        nameLang {
          id
          en
          se
          no
          es
        }
      }

      removedVariations {
        id
        name
        nameLang {
          id
          en
          se
          es
          no
        }
      }
      entry {
        id
        item {
          id
          titleLang {
            id
            en
            se
            es
            no
          }
          categories {
            id
            name
          }
          courseType {
            id
            label
            order
          }
        }
      }
    }
  }
`;

export const GET_PENDING_ORDERS_QUERY = gql`
  query GetPendingOrders($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      orders(filter: { status_in: [PENDING] }) {
        ...PendingOrderFragment
      }
    }
  }
  ${FULL_ORDER_FRAGMENT}
`;

export const FULL_ORDER = gql`
  query GetFullOrder($orderId: ID!) {
    order: Order(id: $orderId) {
      ...PendingOrderFragment
    }
  }
  ${FULL_ORDER_FRAGMENT}
`;
